import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./AvatarSettingsContent.scss";
import { TextInputField } from "../input/TextInputField";
import { Column } from "../layout/Column";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import { useCamera } from "./useCamera";
import { Input, Button, makeStyles } from "@fluentui/react-components";
import configManager from "../../singleton/ConfigManager";

const useStyles = makeStyles({
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    height: "100%"
  },
  input: {
    backgroundColor: "rgba(245, 245, 245, 0.1)"
  }
});

export function AvatarSettingsContent({
  displayName,
  displayNameInputRef,
  disableDisplayNameInput,
  onChangeDisplayName,
  avatarPreview,
  displayNamePattern,
  onChangeAvatar,
  avatarContainerClass,
  avatarButtonClass,
  avatarButtonSubmitClass,
  mediaBrowserOpened,
  enterInAR = false,
  scene,
  callbackOpen,
  onSubmit,
  ...rest
}) {
  const classes = useStyles();
  const isInAvatarEditor = window.APP?.mediaSearchStore?.history?.location?.state?.value === "avatar-editor";
  const isMobile = AFRAME.utils.device.isMobile();
  const isMobileVR = AFRAME.utils.device.isMobileVR();
  const showAvatarName = configManager.config.avatarDialog?.showName;
  const showAvatarPreview = configManager.config.avatarDialog?.showPreview;
  const showChangeAvatarButton = configManager.config.avatarDialog?.changeAvatar;

  const handleSubmit = event => {
    event.preventDefault();
    if (callbackOpen) {
      callbackOpen(onSubmit);
    }
  };

  return (
    <form id="avatar-settings-form" className={classes.form} as="form" onSubmit={handleSubmit} {...rest}>
      {showAvatarName && (
        <Input
          id="avatar-name-input"
          appearance="filled-lighter"
          required
          value={displayName}
          disabled={disableDisplayNameInput}
          onChange={onChangeDisplayName}
          placeholder="Name"
          className={classes.input}
        />
      )}

      {showAvatarPreview && (
        <div id="avatar-preview-container" className={classNames(styles.avatarPreviewContainer, avatarContainerClass)}>
          {isInAvatarEditor || mediaBrowserOpened ? <div /> : avatarPreview}
        </div>
      )}
      <Button id="avatar-accept-button" appearance="primary" type="submit" style={{minHeight: "32px"}}>
        <FormattedMessage id="button.accept" defaultMessage="Accept" />
      </Button>
      {showChangeAvatarButton && (
        <Button id="avatar-change-button" style={{minHeight: "32px"}} className={avatarButtonClass} type="button" preset="accent5" onClick={onChangeAvatar}>
          <FormattedMessage id="avatar-settings-content.change-avatar-button" defaultMessage="Change Avatar" />
        </Button>
      )}
    </form>
  );
}

AvatarSettingsContent.propTypes = {
  className: PropTypes.string,
  displayName: PropTypes.string,
  displayNameInputRef: PropTypes.func,
  disableDisplayNameInput: PropTypes.bool,
  displayNamePattern: PropTypes.string,
  onChangeDisplayName: PropTypes.func,
  avatarPreview: PropTypes.node,
  onChangeAvatar: PropTypes.func
};
